export const NOTE_KEYS = {
    base: 'notes',
    all: ['notes'],
    list: (ticketId: string) => ['notes', 'list', ticketId]
} as const;
